export type VehiclePhotoDTO = {
  fileId: string;
};
